import styled from 'styled-components';

const FormInputErrorStyled = styled.div`
  color: #f44d84;
  margin-top: -0.5rem;
`;

export default FormInputErrorStyled;
